import { useContext } from "react";
import moment from "moment";
import styled from "styled-components";
import { Card, HTMLTable } from "@blueprintjs/core";

import { useOrg } from "@hooks";

import { WorkbenchContext } from "@pages/editor/providers";
import { getRecentlyViewedRules } from "@pages/editor/utils";

const TableCard = styled(Card)`
  padding: 0;
  overflow: hidden;
`;

const RuleNameTd = styled.td`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: left;
  // For resizing, see https://stackoverflow.com/questions/15905572/how-can-i-use-ellipses-in-a-fluid-width-table-without-making-each-column-the-sam
  max-width: 1px;
  width: 100%;
`;

const Separator = styled.span`
  color: var(--light-gray2);
`;

const LastViewedTime = styled.span`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

const StyledTable = styled(HTMLTable)`
  width: 100%;
  // Remove pesky top border on table
  td {
    box-shadow: none !important;
  }

  tr td:last-child {
    // shrink last column to fit contents
    width: 1%;
    white-space: nowrap;
  }
`;

export const SplashRecents = () => {
  const org = useOrg();
  const { workbench } = useContext(WorkbenchContext);
  const recentlyVisitedRules = org ? getRecentlyViewedRules(org.name) : [];
  return (
    <TableCard elevation={1}>
      {recentlyVisitedRules.length ? (
        <StyledTable condensed striped interactive>
          <tbody>
            {recentlyVisitedRules.map((rule, idx) => (
              <tr
                key={idx}
                onClick={() => workbench.fetchBundle(rule.file_path)}
              >
                <RuleNameTd>{rule.name}</RuleNameTd>
                <td>
                  <LastViewedTime>
                    <Separator>|</Separator>
                    <div>{moment(new Date(rule.last_viewed)).fromNow()}</div>
                  </LastViewedTime>
                </td>
              </tr>
            ))}
          </tbody>
        </StyledTable>
      ) : (
        <div style={{ padding: "8px" }}>No recently viewed rules</div>
      )}
    </TableCard>
  );
};
